import { useFormContext } from 'react-hook-form';

import { getBuildLearningMaterialSchema } from './BuildLearningMaterialSchema';
import { getBuildPublisherInfoSchema } from './BuildPublisherInfoSchema';
import { getBuildQuizListSchema } from './BuildQuizListSchema';
import { getBuildQuizSetBasicInfoSchema } from './BuildQuizSetBasicInfoSchema';
import { getBuildQuizSetOptionSchema } from './BuildQuizSetOptionSchema';
import { getBuildSchoolInfoSchema } from './BuildSchoolInfoSchema';

export const BuildSchema = getBuildQuizListSchema()
  .and(getBuildLearningMaterialSchema())
  .and(getBuildPublisherInfoSchema())
  .and(getBuildQuizSetBasicInfoSchema())
  .and(getBuildQuizSetOptionSchema())
  .and(
    getBuildSchoolInfoSchema({
      // 구체적인 데이터 정보들은 runtime에서 hook 등으로 주입합니다.
      schoolNodes: [],
      gradeNodes: [],
      semesterNodes: [],
    }),
  );

export type BuildSchemaInputType = Zod.infer<typeof BuildSchema>;
export type BuildSchemaOutputType = Zod.infer<typeof BuildSchema>;
export type BuildSchemaTypeKey = keyof BuildSchemaInputType;
export const useBuildFormContext = () => useFormContext<BuildSchemaInputType>();

export { QUIZ_SET_TITLE_MAX_LENGTH } from './BuildQuizSetBasicInfoSchema';
